import { IPayOrder, PayPlatform } from "@/common/entity/PayOrder";
import { request, UrlPath } from "@/request";

function aliOrder(
    outTradeNo: string,
    isShowToast: boolean = true
): Promise<{ order: IPayOrder }> {
    return request<{ order: IPayOrder }>(
        {
            url: UrlPath.queryOrder,
            data: {
                outTradeNo,
                payPlatform: PayPlatform.alipay,
            },
        },
        isShowToast
    );
}

export const PayOrderApi = {
    aliOrder,
};
